<template>
	<div v-if="isDevops && connected">
		<!-- Inline mode: rendered as nav items inside the navigation drawer -->
		<template v-if="inline">
			<v-list v-if="clinicName" nav dense class="devops-inline-nav py-0">
				<v-list-item class="devops-inline-item" @click.stop="openDialog">
					<v-list-item-icon class="mr-2">
						<v-icon color="white">mdi-hospital-building</v-icon>
					</v-list-item-icon>
					<v-list-item-content class="ml-2">
						<v-list-item-title class="devops-inline-title text-truncate">
							{{ clinicName }}
						</v-list-item-title>
						<v-list-item-subtitle class="devops-inline-subtitle">
							{{ clinicId }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
				<v-list-item class="devops-inline-item">
					<v-list-item-icon class="mr-2">
						<v-menu
							v-model="toolsMenuOpen"
							offset-x
							right
							nudge-right="8"
							:close-on-content-click="false"
						>
							<template #activator="{ on, attrs }">
								<v-icon color="white" v-bind="attrs" v-on="on">mdi-toolbox</v-icon>
							</template>
							<v-list dense class="tools-menu py-1">
								<v-list-item @click="openToolDialog('devops')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="teal">mdi-cog-play</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('devops-actions') }}</v-list-item-title>
								</v-list-item>
								<v-subheader class="tools-section-header">
									{{ $t('tools-phone-related') }}
								</v-subheader>
								<v-list-item @click="openToolDialog('telephony')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="cyan darken-1">mdi-phone-settings</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('telephony-panel') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('emergency')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="red darken-1">mdi-map-marker-alert</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('emergency-address-compliance') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('twilioDebug')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="red darken-2">mdi-bug-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('twilio-debug-panel') }}</v-list-item-title>
								</v-list-item>
								<v-subheader class="tools-section-header">
									{{ $t('tools-agent-related') }}
								</v-subheader>
								<v-list-item @click="openToolDialog('agent')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="deep-purple">mdi-robot-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('agent-panel') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('erp')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="teal">mdi-database-sync-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('erp-integration-panel') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('connector')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="success">mdi-connection</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('connector.panel-title') }}</v-list-item-title>
								</v-list-item>
								<v-subheader class="tools-section-header">
									{{ $t('tools-other') }}
								</v-subheader>
								<v-list-item @click="openToolDialog('api')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="indigo">mdi-api</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('api-explorer') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('ticketing')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="deep-purple">mdi-clipboard-text-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('ticketing.title-menu') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('invitation')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="amber darken-2">mdi-ticket-confirmation-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('invitation-code') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('pitr')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="brown darken-1">mdi-history</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('pitr-title') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('admin')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="orange">mdi-shield-lock</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('status-configuration') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('system')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="blue-grey darken-2">mdi-information-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('system-info') }}</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</v-list-item-icon>
					<v-list-item-content class="ml-2" @click="toolsMenuOpen = !toolsMenuOpen">
						<v-list-item-title class="devops-inline-title">
							{{ $t('devops-actions') }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</template>

		<!-- Floating mode: fixed-position overlay chip -->
		<template v-else>
			<div
				v-if="clinicName && (!$vuetify.breakpoint.xs || mobileVisible)"
				class="indicator-wrap"
				:class="{ 'mobile-top-center-wrap': $vuetify.breakpoint.xs && mobileVisible }"
			>
				<div class="devops-indicator">
					<div class="indicator-content">
						<v-icon small class="indicator-icon">mdi-hospital-building</v-icon>
						<div class="clinic-details" @click="openDialog">
							<span class="clinic-name text-truncate">{{ clinicName }}</span>
							<span class="clinic-id">{{ clinicId }}</span>
						</div>
						<v-btn
							icon
							x-small
							class="copy-indicator-btn"
							@click.stop="copyToClipboard(clinicId)"
						>
							<v-icon x-small>mdi-content-copy</v-icon>
						</v-btn>
						<v-divider vertical class="indicator-divider mx-1" />
						<v-menu
							v-model="toolsMenuOpen"
							offset-y
							top
							nudge-top="8"
							:close-on-content-click="false"
						>
							<template #activator="{ on, attrs }">
								<v-btn
									icon
									x-small
									class="actions-indicator-btn"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon x-small>mdi-toolbox</v-icon>
								</v-btn>
							</template>
							<v-list dense class="tools-menu py-1">
								<v-list-item @click="openToolDialog('devops')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="teal">mdi-cog-play</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('devops-actions') }}</v-list-item-title>
								</v-list-item>
								<!-- Phone related -->
								<v-subheader class="tools-section-header">
									{{ $t('tools-phone-related') }}
								</v-subheader>
								<v-list-item @click="openToolDialog('telephony')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="cyan darken-1">mdi-phone-settings</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('telephony-panel') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('emergency')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="red darken-1">mdi-map-marker-alert</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('emergency-address-compliance') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('twilioDebug')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="red darken-2">mdi-bug-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('twilio-debug-panel') }}</v-list-item-title>
								</v-list-item>

								<!-- Agent related -->
								<v-subheader class="tools-section-header">
									{{ $t('tools-agent-related') }}
								</v-subheader>
								<v-list-item @click="openToolDialog('agent')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="deep-purple">mdi-robot-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('agent-panel') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('erp')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="teal">mdi-database-sync-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('erp-integration-panel') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('connector')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="success">mdi-connection</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('connector.panel-title') }}</v-list-item-title>
								</v-list-item>

								<!-- Other -->
								<v-subheader class="tools-section-header">
									{{ $t('tools-other') }}
								</v-subheader>
								<v-list-item @click="openToolDialog('api')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="indigo">mdi-api</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('api-explorer') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('ticketing')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="deep-purple">mdi-clipboard-text-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('ticketing.title-menu') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('invitation')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="amber darken-2">mdi-ticket-confirmation-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('invitation-code') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('pitr')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="brown darken-1">mdi-history</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('pitr-title') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('admin')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="orange">mdi-shield-lock</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('status-configuration') }}</v-list-item-title>
								</v-list-item>
								<v-list-item @click="openToolDialog('system')">
									<v-list-item-icon class="mr-3">
										<v-icon small color="blue-grey darken-2">mdi-information-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-title>{{ $t('system-info') }}</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
						<v-icon small class="chevron-icon" @click="openDialog">mdi-chevron-up</v-icon>
					</div>
				</div>
				<div class="ticketing-pill-wrap">
					<button
						type="button"
						class="ticketing-pill"
						:title="$t('ticketing.title-menu')"
						@click="onTicketingPillClick"
					>
						<v-icon small color="white">mdi-clipboard-text-outline</v-icon>
						<span v-if="unreadTicketingCount > 0" class="ticketing-badge">
							{{ unreadTicketingCount }}
						</span>
						<transition-group name="notif-toast" tag="div" class="notif-toast-stack" @click.stop>
							<div
								v-for="t in notifToasts"
								:key="t.id"
								class="notif-toast"
								@click.stop="openToastTicket(t)"
							>
								<div v-if="t.ticketTitle || t.organizationName" class="notif-toast__context">
									<div v-if="t.ticketTitle" class="notif-toast__row">
										<span class="notif-toast__emoji">🎟️</span><span class="notif-toast__ticket text-truncate">{{ t.ticketTitle }}</span>
									</div>
									<div v-if="t.organizationName" class="notif-toast__row">
										<span class="notif-toast__emoji">🏢</span><span class="notif-toast__org text-truncate">{{ t.organizationName }}</span>
									</div>
								</div>
								<div class="notif-toast__msg">
									<template v-if="t.type === 'ticket_updated' && t.field">
										<span class="font-weight-medium">{{ t.actorName || $t('ticketing.someone') }}</span>
										{{ ' ' + $t('ticketing.activity-changed', { field: $t('ticketing.field.' + t.field) }) }}
										<span v-if="t.fromValue != null && t.fromValue !== ''" class="grey--text text--lighten-1">
											{{ ' ' + $t('ticketing.activity-from') }}
										</span>
										<span v-if="t.fromValue != null && t.fromValue !== ''" class="notif-toast__value">{{ t.fromValue }}</span>
										<span class="grey--text text--lighten-1">
											{{ ' ' + $t('ticketing.activity-to') }}
										</span>
										<span class="notif-toast__value">{{ t.toValue || '—' }}</span>
									</template>
									<template v-else-if="t.type === 'attachments_added'">
										<span class="font-weight-medium">{{ t.actorName || $t('ticketing.someone') }}</span>
										{{ ' ' + $t('ticketing.activity-attachments-added') }}
										<span class="notif-toast__value">{{ t.toValue }}</span>
									</template>
									<template v-else-if="t.type === 'attachments_removed'">
										<span class="font-weight-medium">{{ t.actorName || $t('ticketing.someone') }}</span>
										{{ ' ' + $t('ticketing.activity-attachments-removed') }}
										<span class="notif-toast__value">{{ t.toValue }}</span>
									</template>
									<template v-else-if="t.type === 'watcher_added'">
										<span class="font-weight-medium">{{ t.actorName || $t('ticketing.someone') }}</span>
										{{ ' ' + $t('ticketing.activity-watcher-added') }}
										<span class="notif-toast__value">{{ t.toValue }}</span>
									</template>
									<template v-else-if="t.type === 'watcher_removed'">
										<span class="font-weight-medium">{{ t.actorName || $t('ticketing.someone') }}</span>
										{{ ' ' + $t('ticketing.activity-watcher-removed') }}
										<span class="notif-toast__value">{{ t.toValue }}</span>
									</template>
									<template v-else>
										{{ t.message }}
									</template>
								</div>
							</div>
						</transition-group>
					</button>
					<v-menu
						v-model="ticketingNotifMenuOpen"
						:close-on-content-click="false"
						:close-on-click="true"
						top
						offset-y
						:nudge-top="8"
						min-width="380"
						max-width="380"
						transition="slide-y-reverse-transition"
						:position-x="notifMenuPositionX"
						:position-y="notifMenuPositionY"
						absolute
					>
						<ticketing-notifications-panel
							:notifications="ticketingNotifications"
							:unread-count="unreadTicketingCount"
							@notification-click="onNotifPanelClick"
							@mark-all-read="onNotifPanelMarkAllRead"
							@clear-all="onNotifPanelClearAll"
							@remove="onNotifPanelRemove"
						/>
					</v-menu>
				</div>
			</div>
		</template>

		<!-- Impersonate Dialog -->
		<v-dialog
			v-model="dialogOpen"
			max-width="560"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-impersonate"
		>
			<v-card class="dialog-card">
				<div class="dialog-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-swap-horizontal-circle</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t("impersonate") }}</span>
							<span class="header-subtitle">{{ $t('select-organization') || 'Select an organization' }}</span>
						</div>
					</div>
					<v-btn icon class="close-btn" @click="dialogOpen = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>

				<v-card-text class="impersonate-content pa-0">
					<div class="search-container">
						<v-text-field
							ref="searchField"
							v-model="searchText"
							:placeholder="$t('search') + '...'"
							prepend-inner-icon="mdi-magnify"
							clearable
							hide-details
							outlined
							dense
							class="search-field"
						/>
						<div v-if="filteredOrganizations.length" class="results-count">
							{{ filteredOrganizations.length }} {{ filteredOrganizations.length === 1 ? 'organization' : 'organizations' }}
						</div>
					</div>

					<div v-if="filteredOrganizations.length" class="organization-list">
						<v-virtual-scroll ref="virtualScroll" :items="filteredOrganizations" :item-height="64" :height="impersonateListHeight">
							<template #default="{ item }">
								<div
									:class="[
										'org-list-item',
										{ 'is-selected': selected === item.id }
									]"
									@click="selected = item.id"
									@dblclick="item.id !== clinicId && impersonate(item.id)"
								>
									<div class="org-avatar">
										<img
											v-if="hasValidLogo(item)"
											:src="item.logo"
											:alt="organizationName(item.name)"
											class="org-logo"
											@error="onLogoError(item.id)"
										>
										<span v-else>{{ getInitials(organizationName(item.name)) }}</span>
									</div>
									<div class="org-info">
										<span class="org-name text-truncate">{{ organizationName(item.name) }}</span>
										<span class="org-id">ID: {{ item.id }}</span>
									</div>
									<div class="org-actions">
										<v-chip
											v-if="item.id === clinicId"
											x-small
											color="primary"
											text-color="white"
											class="current-chip"
										>
											{{ $t('current') || 'Current' }}
										</v-chip>
										<v-btn
											icon
											small
											class="action-btn copy-btn"
											@click.stop="copyToClipboard(item.id)"
										>
											<v-icon small>mdi-content-copy</v-icon>
										</v-btn>
										<v-btn
											v-if="item.id !== clinicId"
											icon
											small
											class="action-btn switch-btn"
											@click.stop="impersonate(item.id)"
										>
											<v-icon small>mdi-login-variant</v-icon>
										</v-btn>
									</div>
								</div>
							</template>
						</v-virtual-scroll>
					</div>

					<!-- Empty state -->
					<div v-else-if="searchText" class="empty-state" :style="{ height: impersonateListHeight + 'px' }">
						<v-icon large color="grey lighten-1">mdi-magnify-close</v-icon>
						<span>{{ $t('no-results') || 'No organizations found' }}</span>
					</div>
				</v-card-text>

				<!-- Footer with keyboard hints -->
				<div class="dialog-footer">
					<div class="keyboard-hints">
						<span class="hint"><kbd>↑↓</kbd> {{ $t('navigate') }}</span>
						<span class="hint"><kbd>Enter</kbd> {{ $t('switch') }}</span>
						<span class="hint"><kbd>Esc</kbd> {{ $t('close') }}</span>
					</div>
				</div>
			</v-card>
		</v-dialog>

		<!-- Devops Actions Dialog -->
		<v-dialog
			v-model="actionsDialogOpen"
			max-width="650"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-devops"
		>
			<v-card class="dialog-card">
				<div class="dialog-header devops-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-cog-play</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('devops-actions') }}</span>
							<span class="header-subtitle">{{ organizationName(clinicData?.name) }} ({{ clinicId }})</span>
						</div>
					</div>
					<v-btn icon class="close-btn" @click="actionsDialogOpen = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>

				<v-card-text class="tool-dialog-content pa-0">
					<devops-actions ref="devopsActions" embedded />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Telephony Panel Dialog -->
		<v-dialog
			v-model="telephonyDialogOpen"
			max-width="900"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-telephony"
		>
			<v-card class="dialog-card">
				<div class="dialog-header telephony-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-phone-settings</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('telephony-panel') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="telephonyRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': telephonyRefreshError }">
								<template v-if="telephonySecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: telephonySecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="telephonyDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content telephony-dialog-content pa-0">
					<telephony-panel
						v-if="telephonyDialogOpen"
						ref="telephonyPanel"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Admin Status Dialog -->
		<v-dialog
			v-model="adminDialogOpen"
			max-width="650"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-admin"
			scrollable
		>
			<v-card class="dialog-card">
				<div class="dialog-header admin-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-shield-lock</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('status-configuration') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<v-btn icon class="close-btn" @click="adminDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="admin-dialog-content pa-0">
					<admin-form v-if="adminDialogOpen" ref="adminForm" @status-updated="onStatusUpdated" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Agent Panel Dialog -->
		<v-dialog
			v-model="agentDialogOpen"
			max-width="750"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-agent"
		>
			<v-card class="dialog-card">
				<div class="dialog-header agent-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-robot-outline</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('agent-panel') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="agentRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': agentRefreshError }">
								<template v-if="agentSecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: agentSecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="agentDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<agent-panel v-if="agentDialogOpen" ref="agentPanel" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- ERP Integration Dialog -->
		<v-dialog
			v-model="erpDialogOpen"
			max-width="750"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-erp"
		>
			<v-card class="dialog-card">
				<div class="dialog-header erp-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-database-sync-outline</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('erp-integration-panel') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="erpRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': erpRefreshError }">
								<template v-if="erpSecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: erpSecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="erpDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<erp-integration-panel v-if="erpDialogOpen" ref="erpPanel" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Connectors Panel Dialog -->
		<v-dialog
			v-model="connectorDialogOpen"
			max-width="750"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-connector"
		>
			<v-card class="dialog-card">
				<div class="dialog-header connector-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-connection</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('connector.panel-title') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<v-btn icon class="close-btn" @click="connectorDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<connector-panel v-if="connectorDialogOpen" ref="connectorPanel" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Invitation Codes Dialog -->
		<v-dialog
			v-model="invitationDialogOpen"
			max-width="500"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-invitation"
		>
			<v-card class="dialog-card">
				<div class="dialog-header invitation-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-ticket-confirmation-outline</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('invitation-code') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="invitationRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': invitationRefreshError }">
								<template v-if="invitationSecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: invitationSecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="invitationDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="tool-dialog-content pa-0">
					<invitation-code v-if="invitationDialogOpen" ref="invitationCode" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- System Info Dialog -->
		<v-dialog
			v-model="systemDialogOpen"
			max-width="750"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-system"
		>
			<v-card class="dialog-card">
				<div class="dialog-header system-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-information-outline</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('system-info') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="systemRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': systemRefreshError }">
								<template v-if="systemSecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: systemSecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="systemDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<system-info v-if="systemDialogOpen" ref="systemInfo" embedded />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- API Explorer Dialog -->
		<v-dialog
			v-model="apiDialogOpen"
			max-width="900"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-api"
		>
			<v-card class="dialog-card">
				<div class="dialog-header api-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-api</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('api-explorer') }}</span>
							<span class="header-subtitle">{{ $t('test-api-endpoints') || 'Test API endpoints' }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="apiRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': apiRefreshError }">
								<template v-if="apiSecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: apiSecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="apiDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<api-explorer v-if="apiDialogOpen" ref="apiExplorer" embedded />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Emergency Address Compliance Dialog -->
		<v-dialog
			v-model="emergencyDialogOpen"
			max-width="850"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-emergency"
		>
			<v-card class="dialog-card">
				<div class="dialog-header emergency-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-map-marker-alert</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('emergency-address-compliance') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<v-btn
							small
							outlined
							dark
							class="refresh-btn mr-2"
							@click="$refs.emergencyPanel?.fetchReport()"
						>
							<v-icon small>mdi-refresh</v-icon>
						</v-btn>
						<v-btn icon class="close-btn" @click="emergencyDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<emergency-address-panel v-if="emergencyDialogOpen" ref="emergencyPanel" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Twilio Debugging Dialog -->
		<v-dialog
			v-model="twilioDebugDialogOpen"
			max-width="900"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-twilio-debug"
		>
			<v-card class="dialog-card">
				<div class="dialog-header twilio-debug-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-bug-outline</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('twilio-debug-panel') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<div class="auto-refresh-indicator mr-3">
							<v-icon v-if="twilioRefreshError" small color="#ff5252" class="refresh-error-icon">mdi-close-circle</v-icon>
							<v-progress-circular
								v-else
								indeterminate
								size="14"
								width="2"
								color="white"
								class="auto-refresh-spinner"
							/>
							<span class="auto-refresh-text" :class="{ 'refresh-text-error': twilioRefreshError }">
								<template v-if="twilioSecondsAgo != null">{{ $t('refresh-auto-ago', { seconds: twilioSecondsAgo }) }}</template>
								<template v-else>{{ $t('refresh-auto-every', { seconds: 5 }) }}</template>
							</span>
						</div>
						<v-btn icon class="close-btn" @click="twilioDebugDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<twilio-debugging-panel v-if="twilioDebugDialogOpen" ref="twilioDebugPanel" embedded />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Point-in-time Recovery Dialog -->
		<v-dialog
			v-model="pitrDialogOpen"
			max-width="750"
			:fullscreen="$vuetify.breakpoint.xs"
			:persistent="$vuetify.breakpoint.xs"
			content-class="dialog-rounded dialog-pitr"
		>
			<v-card class="dialog-card">
				<div class="dialog-header pitr-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-history</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('pitr-title') }}</span>
							<span class="header-subtitle">{{ $t('pitr-restore-subtitle') }}</span>
						</div>
					</div>
					<div class="header-actions">
						<v-btn
							small
							outlined
							dark
							class="refresh-btn mr-2"
							@click="$refs.pitrPanel?.fetchCollections()"
						>
							<v-icon small>mdi-refresh</v-icon>
						</v-btn>
						<v-btn icon class="close-btn" @click="pitrDialogOpen = false">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<pitr-panel v-if="pitrDialogOpen" ref="pitrPanel" embedded />
				</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Ticketing Dialog -->
		<v-dialog
			v-model="ticketingDialogOpen"
			fullscreen
			persistent
			no-click-animation
			transition="dialog-bottom-transition"
			content-class="dialog-ticketing"
		>
			<v-card class="dialog-card">
				<div class="dialog-header ticketing-header">
					<div class="header-content">
						<div class="header-icon-wrap">
							<v-icon class="header-icon">mdi-clipboard-text-outline</v-icon>
						</div>
						<div class="header-text">
							<span class="header-title">{{ $t('ticketing.title-menu') }}</span>
							<span class="header-subtitle">{{ $t('ticketing.subtitle') }}</span>
						</div>
					</div>
					<v-btn icon class="close-btn" @click="ticketingDialogOpen = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>

				<v-card-text class="panel-dialog-content pa-0">
					<ticketing
						v-if="ticketingDialogOpen"
						embedded
						:open-ticket-id="pendingTicketOpenId"
						:open-ticket-tab="pendingTicketOpenTab"
						@ticket-opened="onTicketOpened"
					/>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { bus } from "@/main.js";
import DevopsActions from "@/components/support/DevopsActions.vue";
import AdminForm from "@/components/support/AdminForm.vue";
import AgentPanel from "@/components/support/AgentPanel.vue";
import ErpIntegrationPanel from "@/components/support/ErpIntegrationPanel.vue";
import ConnectorPanel from "@/components/support/ConnectorPanel.vue";
import InvitationCode from "@/components/support/InvitationCode.vue";
import SystemInfo from "@/components/support/SystemInfo.vue";
import ApiExplorer from "@/components/support/ApiExplorer.vue";
import EmergencyAddressPanel from "@/components/support/EmergencyAddressPanel.vue";
import TelephonyPanel from "@/components/support/TelephonyPanel.vue";
import TwilioDebuggingPanel from "@/components/support/TwilioDebuggingPanel.vue";
import PitrPanel from "@/components/support/PitrPanel.vue";
import Ticketing from "@/components/support/Ticketing.vue";
import TicketingNotificationsPanel from "@/components/support/TicketingNotificationsPanel.vue";
import {
	subscribeNotifications,
	markNotificationRead,
	markAllNotificationsRead,
	deleteNotification,
	deleteAllNotifications
} from "@/composables/ticketing/ticketingStore";
import { waitForEventsAuth } from "@/composables/events/handler";

export default {
	name: "DevopsClinicIndicator",

	components: {
		DevopsActions,
		AdminForm,
		AgentPanel,
		EmergencyAddressPanel,
		ErpIntegrationPanel,
		ConnectorPanel,
		InvitationCode,
		SystemInfo,
		ApiExplorer,
		TelephonyPanel,
		TwilioDebuggingPanel,
		PitrPanel,
		Ticketing,
		TicketingNotificationsPanel
	},

	props: {
		inline: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			dialogOpen: false,
			actionsDialogOpen: false,
			telephonyDialogOpen: false,
			telephonyRefreshing: false,
			telephonyRefreshError: false,
			telephonyLastRefreshedAt: null,
			telephonySecondsAgo: null,
			adminDialogOpen: false,
			agentDialogOpen: false,
			agentRefreshing: false,
			agentRefreshError: false,
			agentLastRefreshedAt: null,
			agentSecondsAgo: null,
			emergencyDialogOpen: false,
			erpDialogOpen: false,
			erpRefreshing: false,
			erpRefreshError: false,
			erpLastRefreshedAt: null,
			connectorDialogOpen: false,
			erpSecondsAgo: null,
			invitationDialogOpen: false,
			invitationRefreshing: false,
			invitationRefreshError: false,
			invitationLastRefreshedAt: null,
			invitationSecondsAgo: null,
			systemDialogOpen: false,
			systemRefreshing: false,
			systemRefreshError: false,
			systemLastRefreshedAt: null,
			systemSecondsAgo: null,
			apiDialogOpen: false,
			apiRefreshing: false,
			apiRefreshError: false,
			apiLastRefreshedAt: null,
			apiSecondsAgo: null,
			twilioDebugDialogOpen: false,
			twilioRefreshing: false,
			twilioRefreshError: false,
			twilioLastRefreshedAt: null,
			twilioSecondsAgo: null,
			pitrDialogOpen: false,
			ticketingDialogOpen: false,
			pendingTicketOpenId: null,
			pendingTicketOpenTab: null,
			toolsMenuOpen: false,
			unreadTicketingCount: 0,
			ticketingNotifications: [],
			ticketingNotifMenuOpen: false,
			notifMenuPositionX: 0,
			notifMenuPositionY: 0,
			unsubTicketingNotif: null,
			notifToasts: [],
			knownNotifIds: null,
			organizations: [],
			searchText: "",
			debouncedSearchText: "",
			loading: false,
			selected: null,
			failedLogos: {},
			searchDebounceTimer: null,
			mobileVisible: false
		};
	},

	computed: {
		...mapGetters("login", ["isDevops", "connected"]),
		...mapGetters("clinic", ["clinicData"]),

		ticketingProfileId() {
			return this.$store.state.login?.profile?.id;
		},

		clinicName() {
			return this.$store.state.clinic.clinicName;
		},

		clinicId() {
			return this.clinicData?.id;
		},

		filteredOrganizations() {
			if (!this.debouncedSearchText) {
				return this.organizations;
			}

			const searchNormalized = this.normalizeText(this.debouncedSearchText);

			return this.organizations.filter(org => {
				const orgName = this.normalizeText(this.organizationName(org.name));
				const orgId = this.normalizeText(org.id.toString());

				return orgName.includes(searchNormalized) || orgId.includes(searchNormalized);
			});
		},

		impersonateListHeight() {
			if (this.$vuetify.breakpoint.xs) {
				// fullscreen: viewport - header(80) - search(~80) - footer(48)
				return window.innerHeight - 208;
			}
			return 322;
		}
	},

	watch: {
		dialogOpen(isOpen) {
			if (isOpen) {
				document.addEventListener("keydown", this.handleKeydown);
			} else {
				document.removeEventListener("keydown", this.handleKeydown);
				this.searchText = "";
				this.debouncedSearchText = "";
				clearTimeout(this.searchDebounceTimer);
			}
		},

		searchText(newVal, oldVal) {
			clearTimeout(this.searchDebounceTimer);

			if (!newVal) {
				// Instant clear for better UX
				this.debouncedSearchText = "";
				if (oldVal) {
					this.$nextTick(() => {
						this.scrollToSelected();
					});
				}
			} else {
				// Debounce search input
				this.searchDebounceTimer = setTimeout(() => {
					this.debouncedSearchText = newVal;
				}, 150);
			}
		},

		telephonyDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("telephony", () => this.$refs.telephonyPanel?.silentRefreshAll?.(), 5000);
			} else {
				this.stopPanelAutoRefresh("telephony");
			}
		},

		agentDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("agent", () => this.$refs.agentPanel?.fetchAgents?.({ silent: true }));
			} else {
				this.stopPanelAutoRefresh("agent");
			}
		},

		erpDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("erp", () => this.$refs.erpPanel?.fetchIntegrations?.({ silent: true }));
			} else {
				this.stopPanelAutoRefresh("erp");
			}
		},

		invitationDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("invitation", () => this.$refs.invitationCode?.fetchInvitations?.({ silent: true }));
			} else {
				this.stopPanelAutoRefresh("invitation");
			}
		},

		systemDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("system", () => this.$refs.systemInfo?.fetchInfo?.({ silent: true }));
			} else {
				this.stopPanelAutoRefresh("system");
			}
		},

		apiDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("api", () => this.$refs.apiExplorer?.fetchSpec?.({ silent: true }));
			} else {
				this.stopPanelAutoRefresh("api");
			}
		},

		twilioDebugDialogOpen(open) {
			if (open) {
				this.startPanelAutoRefresh("twilio", () => this.$refs.twilioDebugPanel?.fetchDebugData?.({ silent: true }));
			} else {
				this.stopPanelAutoRefresh("twilio");
			}
		},

		isDevops() {
			this.maybeStartTicketingSubscription();
		},

		connected() {
			this.maybeStartTicketingSubscription();
		},

		ticketingProfileId() {
			this.maybeStartTicketingSubscription();
		}
	},

	beforeDestroy() {
		["telephony", "agent", "erp", "invitation", "system", "api", "twilio"].forEach(key => {
			clearInterval(this.autoRefreshTimers[key]);
			clearInterval(this.secondsAgoTimers[key]);
		});
		document.removeEventListener("keydown", this.handleKeydown);
		clearTimeout(this.searchDebounceTimer);
		bus.$off("toggle-devops-indicator", this.toggleMobileVisibility);
		this.unsubTicketingNotif?.();
		this.unsubTicketingNotif = null;
	},

	created() {
		bus.$on("toggle-devops-indicator", this.toggleMobileVisibility);
		// Non-reactive timer storage (not in data() to avoid Vue 2 underscore-prefix proxy issue)
		this.autoRefreshTimers = {};
		this.secondsAgoTimers = {};
		this.maybeStartTicketingSubscription();
		this.maybeOpenSharedTicket();
	},

	methods: {
		...mapActions("login", ["logout"]),

		toggleMobileVisibility() {
			this.mobileVisible = !this.mobileVisible;
		},

		async maybeStartTicketingSubscription() {
			if (this.unsubTicketingNotif) return;
			if (!this.isDevops || !this.connected) return;
			const userId = this.ticketingProfileId;

			if (!userId) return;
			try {
				// Wait until Firebase Auth has a signed-in user; right after
				// login, `connected` flips true before signInEvents resolves,
				// so starting the subscription too early yields a permission
				// error and we'd never see the unread badge until a refresh.
				await waitForEventsAuth();
				if (this.unsubTicketingNotif) return;
				if (this.ticketingProfileId !== userId) return;
				this.unsubTicketingNotif = subscribeNotifications(
					userId,
					(items) => {
						this.ticketingNotifications = items;
						this.unreadTicketingCount = items.filter((n) => !n.read).length;
						this.handleNotifSnapshot(items);
					},
					(err) => console.warn("[TICKETING] notif badge subscribe failed", err)
				);
			} catch (err) {
				console.warn("[TICKETING] notif badge bootstrap failed", err);
			}
		},

		handleNotifSnapshot(items) {
			// First snapshot: just record what's already there, don't toast.
			if (this.knownNotifIds === null) {
				this.knownNotifIds = new Set(items.map((n) => n.id));
				return;
			}
			const fresh = items.filter((n) => !n.read && !this.knownNotifIds.has(n.id));

			fresh.forEach((n) => this.knownNotifIds.add(n.id));
			items.forEach((n) => this.knownNotifIds.add(n.id));
			fresh
				.sort((a, b) => (a.createdAt?.toMillis?.() ?? 0) - (b.createdAt?.toMillis?.() ?? 0))
				.forEach((n) => this.pushNotifToast(n));
		},

		pushNotifToast(n) {
			const toast = {
				id: n.id,
				ticketId: n.ticketId || null,
				ticketTitle: n.ticketTitle || "",
				organizationName: n.organizationName || "",
				type: n.type || "",
				field: n.field || "",
				fromValue: n.fromValue ?? null,
				toValue: n.toValue ?? null,
				actorName: n.actorName || "",
				message: n.message || ""
			};

			this.notifToasts.push(toast);
			setTimeout(() => {
				const idx = this.notifToasts.findIndex((t) => t.id === toast.id);

				if (idx !== -1) this.notifToasts.splice(idx, 1);
			}, 10000);
		},

		openToastTicket(toast) {
			const idx = this.notifToasts.findIndex((t) => t.id === toast.id);

			if (idx !== -1) this.notifToasts.splice(idx, 1);
			const convTypes = ["new_message", "mention", "reaction"];

			this.pendingTicketOpenId = toast.ticketId || null;
			this.pendingTicketOpenTab = convTypes.includes(toast.type) ? "conversation" : null;
			this.openToolDialog("ticketing");
		},

		onTicketingPillClick(ev) {
			// When the ticketing dialog is already open, the bubble acts as a
			// quick toggle for the notifications panel (anchored above the bubble).
			// Otherwise it opens the ticketing dialog like before.
			if (this.ticketingDialogOpen) {
				if (!this.ticketingNotifMenuOpen) {
					const btn = ev && ev.currentTarget;
					const rect = btn && btn.getBoundingClientRect
						? btn.getBoundingClientRect()
						: null;

					if (rect) {
						const menuWidth = 380;
						const centerX = rect.left + rect.width / 2;

						this.notifMenuPositionX = centerX - menuWidth / 2;
						this.notifMenuPositionY = rect.top;
					}
				}
				this.ticketingNotifMenuOpen = !this.ticketingNotifMenuOpen;
				return;
			}
			this.openToolDialog("ticketing");
		},

		async onNotifPanelClick(n) {
			this.ticketingNotifMenuOpen = false;
			if (!n.read && this.ticketingProfileId) {
				try {
					await markNotificationRead(this.ticketingProfileId, n.id);
				} catch (_) { /* noop */ }
			}
			if (!n.ticketId) return;
			const convTypes = ["new_message", "mention", "reaction"];

			this.pendingTicketOpenId = n.ticketId;
			this.pendingTicketOpenTab = convTypes.includes(n.type) ? "conversation" : null;
			this.openToolDialog("ticketing");
		},

		async onNotifPanelMarkAllRead() {
			if (!this.ticketingProfileId) return;
			try {
				await markAllNotificationsRead(this.ticketingProfileId);
			} catch (_) { /* noop */ }
		},

		async onNotifPanelRemove(id) {
			if (!this.ticketingProfileId) return;
			try {
				await deleteNotification(this.ticketingProfileId, id);
			} catch (_) { /* noop */ }
		},

		async onNotifPanelClearAll() {
			if (!this.ticketingProfileId) return;
			try {
				await deleteAllNotifications(this.ticketingProfileId);
			} catch (_) { /* noop */ }
		},

		onTicketOpened() {
			this.pendingTicketOpenId = null;
			this.pendingTicketOpenTab = null;
		},

		maybeOpenSharedTicket() {
			try {
				const params = new URLSearchParams(window.location.search);
				const ticketId = params.get("ticket");

				if (!ticketId) return;
				const tab = params.get("tab");

				this.pendingTicketOpenId = ticketId;
				this.pendingTicketOpenTab = tab || null;
				// Strip the param from the URL so refreshes don't keep reopening it.
				params.delete("ticket");
				params.delete("tab");
				const qs = params.toString();
				const newUrl = window.location.pathname + (qs ? `?${qs}` : "") + window.location.hash;

				window.history.replaceState({}, "", newUrl);
				this.$nextTick(() => this.openToolDialog("ticketing"));
			} catch (err) {
				console.warn("[TICKETING] shared ticket open failed", err);
			}
		},

		startPanelAutoRefresh(key, fetchFn, interval = 5000) {
			const refreshingKey = `${key}Refreshing`;
			const errorKey = `${key}RefreshError`;
			const lastRefreshedKey = `${key}LastRefreshedAt`;
			const secondsAgoKey = `${key}SecondsAgo`;

			// Reset state so stale values from a previous session don't bleed through
			this[lastRefreshedKey] = null;
			this[secondsAgoKey] = null;
			this[errorKey] = false;
			this[refreshingKey] = false;

			const doFetch = async () => {
				if (this[refreshingKey]) return;
				if (!this.autoRefreshTimers[key]) return;
				this[refreshingKey] = true;

				try {
					const result = await fetchFn();
					// Bail out if panel was closed while fetch was in-flight

					if (!this.autoRefreshTimers[key]) return;
					const success = result?.success !== false;

					this[errorKey] = !success;
					if (success) {
						this[lastRefreshedKey] = Date.now();
					}
				} catch {
					if (!this.autoRefreshTimers[key]) return;
					this[errorKey] = true;
				} finally {
					this[refreshingKey] = false;
				}
			};

			this.autoRefreshTimers[key] = setInterval(doFetch, interval);

			// Start seconds-ago counter
			this.secondsAgoTimers[key] = setInterval(() => {
				if (this[lastRefreshedKey]) {
					this[secondsAgoKey] = Math.floor((Date.now() - this[lastRefreshedKey]) / 1000);
				}
			}, 1000);
		},

		stopPanelAutoRefresh(key) {
			clearInterval(this.autoRefreshTimers[key]);
			clearInterval(this.secondsAgoTimers[key]);
			this.autoRefreshTimers[key] = null;
			this.secondsAgoTimers[key] = null;
			this[`${key}Refreshing`] = false;
			this[`${key}RefreshError`] = false;
			this[`${key}LastRefreshedAt`] = null;
			this[`${key}SecondsAgo`] = null;
		},

		onStatusUpdated() {
			// Emit event to App.vue to refresh status
			bus.$emit("refresh-status");
		},

		openToolDialog(tool) {
			this.toolsMenuOpen = false;
			switch (tool) {
				case "devops":
					this.actionsDialogOpen = true;
					this.$nextTick(() => {
						this.$refs.devopsActions?.scrollToTop();
					});
					break;
				case "telephony":
					this.telephonyDialogOpen = true;
					break;
				case "admin":
					this.adminDialogOpen = true;
					break;
				case "agent":
					this.agentDialogOpen = true;
					break;
				case "emergency":
					this.emergencyDialogOpen = true;
					break;
				case "erp":
					this.erpDialogOpen = true;
					break;
				case "connector":
					this.connectorDialogOpen = true;
					break;
				case "invitation":
					this.invitationDialogOpen = true;
					break;
				case "system":
					this.systemDialogOpen = true;
					break;
				case "api":
					this.apiDialogOpen = true;
					break;
				case "twilioDebug":
					this.twilioDebugDialogOpen = true;
					break;
				case "pitr":
					this.pitrDialogOpen = true;
					break;
				case "ticketing":
					this.ticketingDialogOpen = true;
					break;
			}
		},

		async openDialog() {
			this.dialogOpen = true;
			this.selected = this.clinicId;
			if (this.organizations.length === 0) {
				await this.loadOrganizations();
			}
			this.$nextTick(() => {
				// Don't focus search field on mobile to prevent keyboard from showing
				if (!this.$vuetify.breakpoint.xs) {
					this.$refs.searchField?.focus();
				}
				this.scrollToSelected();
			});
		},

		async loadOrganizations() {
			try {
				this.loading = true;
				this.organizations = (await this.axios.get("/devops/organizations")).data;
			} catch (err) {
				console.error("Failed to load organizations:", err);
			} finally {
				this.loading = false;
			}
		},

		async copyToClipboard(id) {
			try {
				await navigator.clipboard.writeText(id);
				this.$success(this.$t("copied-to-clipboard"));
			} catch (err) {
				console.error("Failed to copy:", err);
			}
		},

		normalizeText(text) {
			return text
				.toLowerCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "");
		},

		getInitials(name) {
			if (!name) return "?";
			return name
				.split(" ")
				.slice(0, 2)
				.map(word => word.charAt(0).toUpperCase())
				.join("");
		},

		hasValidLogo(item) {
			return item.logo && !this.failedLogos[item.id];
		},

		onLogoError(itemId) {
			this.$set(this.failedLogos, itemId, true);
		},

		organizationName(name) {
			if (!name) return "";
			const [locale] = Object.keys(name);

			return name[locale];
		},

		async impersonate(organizationId) {
			try {
				await this.axios.post("/devops/impersonate", { organization: organizationId });
				localStorage.setItem("triggerPasskeyLogin", "true");
				await this.logout();
			} catch (err) {
				console.error("Failed to impersonate:", err);
			}
		},

		impersonateSelected() {
			if (this.selected && this.selected !== this.clinicId) {
				this.impersonate(this.selected);
			}
		},

		handleKeydown(event) {
			if (event.key === "Enter") {
				this.impersonateSelected();
			} else if (event.key === "ArrowDown") {
				event.preventDefault();
				this.navigateList(1);
			} else if (event.key === "ArrowUp") {
				event.preventDefault();
				this.navigateList(-1);
			}
		},

		navigateList(direction) {
			const items = this.filteredOrganizations;

			if (items.length === 0) return;

			const currentIndex = items.findIndex(item => item.id === this.selected);

			let newIndex;

			if (currentIndex === -1) {
				// Nothing selected, start from first (down) or last (up)
				newIndex = direction > 0 ? 0 : items.length - 1;
			} else {
				newIndex = currentIndex + direction;
				// Clamp to bounds
				if (newIndex < 0) newIndex = 0;
				if (newIndex >= items.length) newIndex = items.length - 1;
			}

			this.selected = items[newIndex].id;
			this.scrollToIndex(newIndex);
		},

		scrollToIndex(index) {
			const virtualScroll = this.$refs.virtualScroll;

			if (virtualScroll && virtualScroll.$el) {
				const itemHeight = 64;
				const itemTop = index * itemHeight;

				virtualScroll.$el.scrollTop = itemTop;
			}
		},

		scrollToSelected() {
			if (!this.selected) return;
			const index = this.filteredOrganizations.findIndex(item => item.id === this.selected);

			if (index !== -1) {
				this.scrollToIndex(index);
			}
		}
	}
};
</script>

<style scoped>
	/* Floating Indicator */
	.indicator-wrap {
		position: fixed;
		bottom: 12px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 300;
		display: flex;
		align-items: stretch;
		gap: 8px;
	}

	.indicator-wrap.mobile-top-center-wrap {
		bottom: auto;
		top: 12px;
	}

	.devops-indicator {
		background: linear-gradient(135deg, #3C41C3 0%, #2d3199 100%);
		border-radius: 14px;
		padding: 6px 10px;
		box-shadow: 0 4px 20px rgba(60, 65, 195, 0.35), 0 2px 8px rgba(0, 0, 0, 0.08);
		cursor: pointer;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		opacity: 0.92;
		max-width: 280px;
		backdrop-filter: blur(12px);
		-webkit-backdrop-filter: blur(12px);
	}

	.ticketing-pill-wrap {
		position: relative;
		display: inline-block;
	}

	.ticketing-notif-anchor {
		position: absolute;
		top: 0;
		left: 50%;
		width: 1px;
		height: 1px;
		pointer-events: none;
		opacity: 0;
	}

	.ticketing-pill {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background: linear-gradient(135deg, #3C41C3 0%, #2d3199 100%);
		border-radius: 50%;
		width: 40px;
		height: 40px;
		border: none;
		padding: 0;
		cursor: pointer;
		box-shadow: 0 4px 20px rgba(60, 65, 195, 0.35), 0 2px 8px rgba(0, 0, 0, 0.08);
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		opacity: 0.92;
		align-self: center;
	}

	.ticketing-pill:hover {
		opacity: 1;
		transform: translateY(-3px);
		box-shadow: 0 8px 32px rgba(60, 65, 195, 0.45), 0 4px 16px rgba(0, 0, 0, 0.12);
	}

	.ticketing-badge {
		position: absolute;
		top: -4px;
		right: -4px;
		min-width: 18px;
		height: 18px;
		padding: 0 5px;
		border-radius: 9px;
		background-color: #e53935;
		color: #fff;
		font-size: 10px;
		font-weight: 700;
		line-height: 18px;
		text-align: center;
		box-shadow: 0 0 0 2px #2d3199;
		pointer-events: none;
	}

	.notif-toast-stack {
		position: absolute;
		bottom: calc(100% + 10px);
		right: 0;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: 6px;
		pointer-events: none;
	}

	.notif-toast {
		pointer-events: auto;
		max-width: 280px;
		min-width: 200px;
		padding: 8px 10px;
		border-radius: 10px;
		background: #fff;
		color: rgba(0, 0, 0, 0.85);
		text-align: left;
		font-size: 12px;
		line-height: 1.35;
		box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.08);
		border: 1px solid rgba(0, 0, 0, 0.06);
		cursor: pointer;
	}

	.notif-toast__context {
		font-size: 11px;
		margin-bottom: 2px;
		color: rgba(0, 0, 0, 0.7);
	}

	.notif-toast__row {
		display: flex;
		align-items: center;
		gap: 4px;
		min-width: 0;
		overflow: hidden;
	}

	.notif-toast__emoji {
		font-size: 12px;
		line-height: 1;
		flex-shrink: 0;
	}

	.notif-toast__ticket {
		color: #1565c0;
		font-weight: 500;
	}

	.notif-toast__org {
		color: rgba(0, 0, 0, 0.87);
		font-weight: 700;
	}

	.notif-toast__msg {
		color: rgba(0, 0, 0, 0.78);
		word-break: break-word;
	}

	.notif-toast__value {
		font-weight: 600;
		color: rgba(0, 0, 0, 0.87);
	}

	.notif-toast-enter-active,
	.notif-toast-leave-active {
		transition: opacity 0.25s ease, transform 0.25s ease;
	}
	.notif-toast-enter,
	.notif-toast-leave-to {
		opacity: 0;
		transform: translateY(8px);
	}

	/* Inline nav items styling */
	.devops-inline-nav {
		background: transparent !important;
	}

	.devops-inline-item {
		min-height: 40px;
	}

	.devops-inline-item:first-child {
		align-items: flex-start !important;
		max-height: 40px;
	}

	.devops-inline-item:nth-child(2) {
		margin-bottom: 12px;
	}

	.devops-inline-title {
		color: rgba(255, 255, 255, 0.85) !important;
		font-size: 13px !important;
	}

	.devops-inline-subtitle {
		color: rgba(255, 255, 255, 0.5) !important;
		font-size: 10px !important;
		font-family: monospace;
	}

	.devops-indicator:hover {
		opacity: 1;
		transform: translateY(-3px);
		box-shadow: 0 8px 32px rgba(60, 65, 195, 0.45), 0 4px 16px rgba(0, 0, 0, 0.12);
	}

	.indicator-content {
		display: flex;
		align-items: center;
		gap: 6px;
		color: white;
	}

	.indicator-icon {
		color: rgba(255, 255, 255, 0.9) !important;
	}

	.clinic-details {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}

	.clinic-name {
		font-size: 11px;
		font-weight: 600;
		line-height: 1.2;
		max-width: 180px;
	}

	.clinic-id {
		font-size: 9px;
		opacity: 0.8;
		font-family: monospace;
	}

	.copy-indicator-btn {
		color: white !important;
		opacity: 0.7;
		transition: opacity 0.2s;
	}

	.copy-indicator-btn:hover {
		opacity: 1;
	}

	.indicator-divider {
		border-color: rgba(255, 255, 255, 0.3) !important;
		height: 16px;
		min-height: 16px;
		max-height: 16px;
		align-self: center;
		margin: 0 2px;
	}

	.actions-indicator-btn {
		color: white !important;
		opacity: 0.7;
		transition: opacity 0.2s;
	}

	.actions-indicator-btn:hover {
		opacity: 1;
	}

	.clinic-details {
		cursor: pointer;
	}

	.chevron-icon {
		color: rgba(255, 255, 255, 0.7) !important;
		margin-left: -4px;
		cursor: pointer;
	}

	/* Dialog */
	.dialog-card {
		border-radius: 20px !important;
		overflow: hidden;
		max-height: 90vh;
		display: flex;
		flex-direction: column;
		box-shadow: 0 25px 60px -12px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.03);
	}

	@media (max-width: 599px) {
		.dialog-card {
			border-radius: 0 !important;
			max-height: 100vh;
			max-height: 100dvh;
			height: 100%;
			position: relative;
		}
	}

	.dialog-card > .dialog-header {
		background: linear-gradient(135deg, #3C41C3 0%, #2d3199 100%);
		padding: 22px 28px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.header-actions {
		display: flex;
		align-items: center;
	}

	.refresh-btn {
		border-color: rgba(255, 255, 255, 0.4) !important;
		color: white !important;
		border-radius: 20px !important;
		text-transform: none !important;
		letter-spacing: 0 !important;
		transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
	}

	.refresh-btn:hover {
		border-color: white !important;
		background: rgba(255, 255, 255, 0.15) !important;
		transform: scale(1.04);
	}

	.auto-refresh-indicator {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 6px;
		min-width: 0;
		background: rgba(255, 255, 255, 0.12);
		border-radius: 20px;
		padding: 4px 12px 4px 8px;
		backdrop-filter: blur(4px);
		-webkit-backdrop-filter: blur(4px);
	}

	.auto-refresh-spinner {
		flex-shrink: 0;
	}

	.auto-refresh-text {
		font-size: 10px;
		color: rgba(255, 255, 255, 0.85);
		letter-spacing: 0.02em;
		white-space: nowrap;
		line-height: 1;
		transition: color 0.2s ease;
	}

	.refresh-text-error {
		color: #ff5252;
	}

	.refresh-error-icon {
		font-size: 16px !important;
		line-height: 1;
	}

	.dialog-card > .dialog-header.devops-header {
		background: linear-gradient(135deg, #00897b 0%, #00695c 100%);
	}

	.dialog-card > .dialog-header.sip-header {
		background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
	}

	.dialog-card > .dialog-header.admin-header {
		background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
	}

	.dialog-card > .dialog-header.agent-header {
		background: linear-gradient(135deg, #673ab7 0%, #512da8 100%);
	}

	.dialog-card > .dialog-header.erp-header {
		background: linear-gradient(135deg, #009688 0%, #00796b 100%);
	}

	.dialog-card > .dialog-header.invitation-header {
		background: linear-gradient(135deg, #ffb300 0%, #ff8f00 100%);
	}

	.dialog-card > .dialog-header.system-header {
		background: linear-gradient(135deg, #37474f 0%, #263238 100%);
	}

	.dialog-card > .dialog-header.api-header {
		background: linear-gradient(135deg, #5c6bc0 0%, #3949ab 100%);
	}

	.dialog-card > .dialog-header.emergency-header {
		background: linear-gradient(135deg, #e53935 0%, #c62828 100%);
	}

	.dialog-card > .dialog-header.telephony-header {
		background: linear-gradient(135deg, #00acc1 0%, #006064 100%);
	}

	.dialog-card > .dialog-header.twilio-debug-header {
		background: linear-gradient(135deg, #c62828 0%, #b71c1c 100%);
	}

	.dialog-card > .dialog-header.pitr-header {
		background: linear-gradient(135deg, #6d4c41 0%, #4e342e 100%);
	}

	@media (max-width: 599px) {
		.dialog-card > .dialog-header {
			background: #3C41C3 !important;
		}
		.dialog-card > .dialog-header.devops-header {
			background: #00897b !important;
		}
		.dialog-card > .dialog-header.telephony-header {
			background: #00acc1 !important;
		}
		.dialog-card > .dialog-header.admin-header {
			background: #f57c00 !important;
		}
		.dialog-card > .dialog-header.agent-header {
			background: #673ab7 !important;
		}
		.dialog-card > .dialog-header.erp-header {
			background: #009688 !important;
		}
		.dialog-card > .dialog-header.invitation-header {
			background: #ffb300 !important;
		}
		.dialog-card > .dialog-header.system-header {
			background: #37474f !important;
		}
		.dialog-card > .dialog-header.api-header {
			background: #5c6bc0 !important;
		}
		.dialog-card > .dialog-header.emergency-header {
			background: #e53935 !important;
		}
		.dialog-card > .dialog-header.twilio-debug-header {
			background: #c62828 !important;
		}
		.dialog-card > .dialog-header.pitr-header {
			background: #6d4c41 !important;
		}
	}

	.tool-dialog-content {
		max-height: 500px;
		overflow-y: auto;
	}

	.telephony-dialog-content {
		max-height: 75vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
	}

	.admin-dialog-content {
		overflow-y: auto;
		max-height: 70vh;
	}

	.admin-dialog-content >>> .v-card {
		margin: 0 !important;
	}

	.panel-dialog-content {
		overflow-y: auto;
		overflow-x: hidden;
		flex: 1;
		min-height: 0;
		max-height: calc(90vh - 80px);
		-webkit-overflow-scrolling: touch;
		overscroll-behavior: contain;
	}

	@media (max-width: 599px) {
		.panel-dialog-content {
			max-height: none;
		}

		.telephony-dialog-content {
			max-height: none;
			overflow-y: auto;
		}

		.tool-dialog-content {
			max-height: none;
			flex: 1;
			display: flex;
			flex-direction: column;
		}

		.admin-dialog-content {
			max-height: none;
			flex: 1;
			overflow-y: auto;
		}

		.impersonate-content {
			flex: 1;
			display: flex;
			flex-direction: column;
			overflow: hidden;
		}
	}

	.panel-dialog-content >>> .v-card {
		margin: 0 !important;
	}

	.panel-dialog-content >>> .panel-content {
		max-height: none;
		overflow: visible;
		padding-bottom: 16px;
	}

	.tools-menu {
		min-width: 220px;
		border-radius: 16px !important;
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04) !important;
		padding: 6px !important;
	}

	.tools-menu .v-list-item {
		min-height: 40px;
		border-radius: 10px;
		margin: 1px 0;
		transition: all 0.15s ease;
	}

	.tools-menu .v-list-item:hover {
		background: #f0f1ff;
	}

	.tools-section-header {
		font-size: 10px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.8px;
		height: 28px;
		min-height: 28px;
		padding: 0 12px;
		color: rgba(0, 0, 0, 0.35);
		margin-top: 6px;
	}

	.header-content {
		display: flex;
		align-items: center;
		gap: 14px;
	}

	.header-icon-wrap {
		width: 46px;
		height: 46px;
		border-radius: 14px;
		background: rgba(255, 255, 255, 0.15);
		backdrop-filter: blur(8px);
		-webkit-backdrop-filter: blur(8px);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.header-icon {
		color: white !important;
		font-size: 26px !important;
		opacity: 1;
	}

	.header-text {
		display: flex;
		flex-direction: column;
	}

	.header-title {
		color: white;
		font-size: 17px;
		font-weight: 700;
		line-height: 1.2;
		letter-spacing: -0.01em;
	}

	.header-subtitle {
		color: rgba(255, 255, 255, 0.75);
		font-size: 12px;
		margin-top: 3px;
		font-weight: 400;
	}

	.close-btn {
		color: white !important;
		opacity: 0.85;
		transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
		border-radius: 12px !important;
	}

	.close-btn:hover {
		opacity: 1;
		background: rgba(255, 255, 255, 0.15) !important;
	}

	/* Search */
	.search-container {
		padding: 16px 20px 12px;
		background: linear-gradient(180deg, #fafafd 0%, #f5f6fa 100%);
		border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	}

	.search-field {
		background: white;
		border-radius: 14px;
	}

	.search-field >>> .v-input__slot {
		border-radius: 14px !important;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
	}

	.results-count {
		font-size: 12px;
		color: #888;
		margin-top: 8px;
		padding-left: 4px;
	}

	/* Organization List */
	.organization-list {
		overflow: hidden;
		flex: 1;
	}

	.org-list-item {
		display: flex;
		align-items: center;
		padding: 10px 20px;
		gap: 14px;
		cursor: pointer;
		transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
		border-bottom: 1px solid rgba(0, 0, 0, 0.04);
		height: 64px;
	}

	.org-list-item:hover {
		background: #eef0ff;
	}

	.org-list-item.is-selected {
		background: #e0e2f8;
		border-left: 3px solid #3C41C3;
		padding-left: 17px;
	}

	.org-avatar {
		width: 40px;
		height: 40px;
		border-radius: 12px;
		background: linear-gradient(135deg, #e8e9f7 0%, #d1d3ef 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		font-weight: 600;
		font-size: 14px;
		color: #3C41C3;
		overflow: hidden;
		box-shadow: 0 2px 8px rgba(60, 65, 195, 0.1);
	}

	.org-logo {
		width: 40px;
		height: 40px;
		object-fit: cover;
	}

	.org-info {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.org-name {
		font-size: 14px;
		font-weight: 500;
		color: #1f2937;
		line-height: 1.3;
	}

	.org-id {
		font-size: 12px;
		color: #9ca3af;
		font-family: monospace;
	}

	.org-actions {
		display: flex;
		align-items: center;
		gap: 4px;
		flex-shrink: 0;
	}

	.current-chip {
		font-size: 10px !important;
		height: 22px !important;
		margin-right: 4px;
		border-radius: 8px !important;
		font-weight: 600 !important;
		letter-spacing: 0.02em;
	}

	.action-btn {
		opacity: 0.5;
		transition: all 0.2s;
	}

	.action-btn:hover {
		opacity: 1;
	}

	.copy-btn:hover {
		color: #3C41C3;
	}

	.switch-btn {
		color: #3C41C3 !important;
	}

	.switch-btn:hover {
		background: #e8e9f7 !important;
	}

	/* Empty State */
	.empty-state {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
		color: #9ca3af;
		font-size: 14px;
		flex: 1;
	}

	/* Footer */
	.dialog-footer {
		background: linear-gradient(180deg, #f8f9fe 0%, #f2f3fb 100%);
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 14px 20px;
	}

	.keyboard-hints {
		display: flex;
		gap: 16px;
		justify-content: center;
	}

	.hint {
		font-size: 12px;
		color: #9ca3af;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.hint kbd {
		background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);
		border-radius: 6px;
		padding: 3px 7px;
		font-size: 11px;
		font-family: monospace;
		color: #4b5563;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.06);
	}
</style>

<style>
	/* Lock the fullscreen ticketing dialog in place so the persistent
	   shake animation can't drift it a few pixels. */
	.dialog-ticketing.v-dialog--fullscreen {
		top: 0 !important;
		left: 0 !important;
		transform: none !important;
		animation: none !important;
	}

	.dialog-rounded {
		border-radius: 20px !important;
		overflow: hidden;
	}

	@media (max-width: 599px) {
		.dialog-rounded {
			border-radius: 0 !important;
		}
	}

	.dialog-rounded .v-card__actions .v-btn,
	.dialog-rounded .v-card__text .v-btn:not(.v-btn--icon):not(.v-btn--fab):not(.close-btn):not(.refresh-btn) {
		border-radius: 20px !important;
		text-transform: none !important;
		font-weight: 600 !important;
		letter-spacing: 0 !important;
		min-width: 90px;
		transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
	}

	.dialog-rounded .v-card__actions .v-btn:hover,
	.dialog-rounded .v-card__text .v-btn:not(.v-btn--icon):not(.v-btn--fab):not(.close-btn):not(.refresh-btn):hover {
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	}

	/* iOS PWA: push dialog header below safe area on mobile */
	@media (max-width: 599px) {
		.v-dialog--fullscreen > .dialog-card > .dialog-header {
			padding: calc(env(safe-area-inset-top, 0px) + 10px) 28px 10px;
		}
	}

	/* Fullscreen dialog status-bar coloring (mobile) */
	@media (max-width: 599px) {
		.dialog-impersonate,
		.dialog-impersonate > .v-card {
			background-color: #3C41C3 !important;
		}
		.dialog-devops,
		.dialog-devops > .v-card {
			background-color: #00897b !important;
		}
		.dialog-telephony,
		.dialog-telephony > .v-card {
			background-color: #00acc1 !important;
		}
		.dialog-admin,
		.dialog-admin > .v-card {
			background-color: #f57c00 !important;
		}
		.dialog-agent,
		.dialog-agent > .v-card {
			background-color: #673ab7 !important;
		}
		.dialog-erp,
		.dialog-erp > .v-card {
			background-color: #009688 !important;
		}
		.dialog-invitation,
		.dialog-invitation > .v-card {
			background-color: #ffb300 !important;
		}
		.dialog-system,
		.dialog-system > .v-card {
			background-color: #37474f !important;
		}
		.dialog-api,
		.dialog-api > .v-card {
			background-color: #5c6bc0 !important;
		}
		.dialog-emergency,
		.dialog-emergency > .v-card {
			background-color: #e53935 !important;
		}
		.dialog-twilio-debug,
		.dialog-twilio-debug > .v-card {
			background-color: #c62828 !important;
		}
		.dialog-pitr,
		.dialog-pitr > .v-card {
			background-color: #6d4c41 !important;
		}

		.dialog-rounded > .v-card > *:not(.dialog-header) {
			background-color: #fff !important;
		}

		/* Kill dialog open/close animation so status-bar color applies instantly */
		.dialog-rounded,
		.dialog-rounded > .v-card,
		.v-dialog__content {
			transition: none !important;
		}
	}

</style>